import { AppThunk } from '../../../store/rootReducer';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { smallestStripSelector } from '../../navigation/selectors/navigation.selectors';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import * as rulerActions from '../actions/ruler.actions';
import {
  isMovingRulerSelector,
  isUpdatingRulerSelector,
  previousRulerTimestampSelector,
  rulerRangeSelector,
} from '../selectors/ruler.selectors';

export const setRulerTimestamp =
  (timestamp: number): AppThunk =>
  async (dispatch, getState) => {
    const isUpdatingRuler = isUpdatingRulerSelector(getState());
    const isRulerActive = isToolActiveSelector(Tool.ruler)(getState());
    const duration = roundedDurationSelector(getState());
    const smallestStrip = smallestStripSelector(getState());
    const [start, end] = rulerRangeSelector(getState());
    const prevTimestamp = previousRulerTimestampSelector(getState());
    const isMoving = isMovingRulerSelector(getState());
    let newTimestamp = timestamp;

    let sOnset = 0,
      sOffset = 0;
    if (smallestStrip != null) {
      sOnset = smallestStrip.onset;
      sOffset = smallestStrip.offset;
    }

    if (isMoving && start - (prevTimestamp - timestamp) < 0) {
      newTimestamp = prevTimestamp - start;
    } else if (
      isMoving &&
      end - (prevTimestamp - timestamp) > duration + sOnset + sOffset
    ) {
      newTimestamp = duration + sOnset + sOffset + prevTimestamp - end - 20;
    }

    if (isUpdatingRuler && isRulerActive) {
      dispatch(
        rulerActions.setTimestamp({
          timestamp: newTimestamp,
          meta: { history: false },
        }),
      );
    }
  };
